<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="char"><span class="epub-i">Main Characters</span></p>
<p class="bib2"><span class="epub-bi">Jahangir’s family</span></p>
<p class="bib">Akbar, Jahangir’s father and the third Moghul emperor</p>
<p class="bib">Humayun, Jahangir’s grandfather and the second Moghul emperor</p>
<p class="bib">Hamida, Jahangir’s grandmother</p>
<p class="bib">Kamran, Jahangir’s great-uncle</p>
<p class="bib">Askari, Jahangir’s great-uncle</p>
<p class="bib">Hindal, Jahangir’s great-uncle</p>
<p class="bib">Murad, Jahangir’s brother</p>
<p class="bib">Daniyal, Jahangir’s brother</p>
<p class="bib">Khusrau, Jahangir’s eldest son</p>
<p class="bib">Parvez, Jahangir’s second son</p>
<p class="bib">Khurram (later the Emperor Shah Jahan), Jahangir’s third son</p>
<p class="bib">Shahriyar, Jahangir’s youngest son</p>
<p class="bib">Man Bai, Jahangir’s wife and mother of Khusrau</p>
<p class="bib">Jodh Bai, Jahangir’s wife and mother of Khurram</p>
<p class="bib">Sahib Jamal, Jahangir’s wife and mother of Parvez</p>
<p class="bib">Mehrunissa (also known as Nur Mahal and Nur Jahan), Jahangir’s last wife</p>
<p class="bib2"><span class="epub-bi">Mehrunissa’s family</span></p>
<p class="bib">Ladli, Mehrunissa’s daughter by Sher Afghan</p>
<p class="bib">Ghiyas Beg, Imperial Treasurer and Mehrunissa’s father</p>
<p class="bib">Asmat, mother of Mehrunissa and her brothers</p>
<p class="bib">Asaf Khan, commander of the Agra garrison and Mehrunissa’s elder brother</p>
<p class="bib">Mir Khan, Mehrunissa’s younger brother</p>
<p class="bib">Arjumand Banu, Mehrunissa’s niece, Asaf Khan’s daughter and wife of Khurram (Shah Jahan)</p>
<p class="bib">Sher Afghan, commander of the garrison at Gaur in Bengal, Mehrunissa’s first husband</p>
<p class="bib2"><span class="epub-bi">Jahangir’s commanders, governors and courtiers</span></p>
<p class="bib">Suleiman Beg, Jahangir’s milk-brother</p>
<p class="bib">Ali Khan, Governor of Mandu</p>
<p class="bib">Iqbal Beg, a senior commander in the Deccan</p>
<p class="bib">Mahabat Khan, a Persian and one of Jahangir’s leading generals</p>
<p class="bib">Majid Khan, Jahangir’s vizier and chronicler</p>
<p class="bib">Yar Muhammad, Governor of Gwalior</p>
<p class="bib">Dara Shukoh, Khurram’s (Shah Jahan’s) eldest son</p>
<p class="bib">Shah Shujah, Khurram’s (Shah Jahan’s) second son</p>
<p class="bib">Aurangzeb, Khurram’s (Shah Jahan’s) third son</p>
<p class="bib">Murad Bakhsh, Khurram’s (Shah Jahan’s) youngest son</p>
<p class="bib">Jahanara, Khurram’s (Shah Jahan’s) elder daughter</p>
<p class="bib">Roshanara, Khurram’s (Shah Jahan’s) younger daughter</p>
<p class="bib2"><span class="epub-bi">In the imperial</span> <span class="epub-b">haram</span></p>
<p class="bib">Mala, <span class="epub-i">khawajasara,</span> superintendent, of the imperial <span class="epub-i">haram</span></p>
<p class="bib">Fatima Begam, a widow of the Emperor Akbar</p>
<p class="bib">Nadya, Fatima Begam’s maid</p>
<p class="bib">Salla, Mehrunissa’s Armenian lady-in-waiting</p>
<p class="bib2"><span class="epub-bi">Khurram’s circle</span></p>
<p class="bib">Azam Bahksh, one of Akbar’s aged former commanders</p>
<p class="bib">Kamran Iqbal, one of Khurram’s commanders</p>
<p class="bib">Walid Beg, one of Khurram’s gunnery commanders</p>
<p class="bib2"><span class="epub-bi">Others</span></p>
<p class="bib">Aziz Koka, adherent of Khusrau</p>
<p class="bib">Hassan Jamal, adherent of Khusrau</p>
<p class="bib">Malik Ambar, former Abyssinian slave and now commander of the armies of the Deccan sultanates against the Moghuls</p>
<p class="bib">Shaikh Salim Chishti, a Sufi mystic, and his son, also a Sufi.</p>
<p class="bib2"><span class="epub-bi">Foreigners in the Moghul empire</span></p>
<p class="bib">Bartholomew Hawkins, English soldier and adventurer</p>
<p class="bib">Father Ronaldo, a Portuguese priest</p>
<p class="bib">Sir Thomas Roe, English ambassador to the Moghul court</p>
<p class="bib">Nicholas Ballantyne, squire to Sir Thomas Roe</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// char.vue?71ab4e0c